export default __webpack_public_path__ + "static/media/ms1.511ffed7.jpg";